<template>
    <div id="config-modal" class="modal" v-bind:class="{ 'is-active': visible }">
        <div class="modal-background" @click="hide"></div>
        <div id="modal-content" class="modal-content">  
            <div class="modal-iframe-wrapper">
                <iframe :src="modal.url" class="modal-iframe"></iframe>
            </div>  
        </div>
        <button @click="hide" class="modal-close is-large" aria-label="close"></button>
    </div>  
</template>

<script>
module.exports = {

    data: function () {
        return {
            visible: false,
            //url: ''
        }
    }
    ,
    props: ['modal']
    ,
    methods: {
        hide: function() {
            let htmlTag = document.getElementsByTagName( 'html' )[0]
            htmlTag.classList.remove('modal-active');
            
            //document.body.classList.remove('modal-active');
            
            this.visible = false;
        }
        ,
        show: function() {
            let htmlTag = document.getElementsByTagName( 'html' )[0]
            htmlTag.classList.add('modal-active');

            //document.body.classList.add('modal-active');
            
            this.visible = true;
        }
    }
    ,

    mounted () {
        /*
        console.log('Modal mounted')
        this.iFrameUrl = location.origin + v.config.product_path + '19';
        this.HTMLcontent = '<iframe src="' + this.iFrameUrl + '" style="width: 100%; height: 100vh; max-height: 100vh;"></iframe>'
        this.visible = true
        return true
        */
    }

}
</script>

<style scoped>
    iframe {
        width:100%;
        height: 100%;
    }

    .modal-content {
        width: auto;
    }
</style>